import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            config: 'site/config',
        }),
        allowedTypes() {
            return this.config?.push_notifications || []
        },
    },
    mounted() {
        if (this.$onMessage && this.$isSupported) {
            this.$onMessage(this.$messaging, (payload) => {
                if (this.allowedTypes.includes(payload.data.type)) {
                    const notificationTitle = payload.data.title
                    const notificationOptions = {
                        body: payload.data.body,
                        icon: './images/icon.svg',
                        image: './images/icon.svg',
                    }
                    new Notification(notificationTitle, notificationOptions)
                }
            })
        }
    },
}
